import './PortaitsSectionStyles.css';
import "../../index.css";


const PortraitsSection = ({
  class_Name,
  imageList = [],
  videoSrc,
  mediaOrientation = 'horizontal',
  reverseOnDesktop = false,
  title,
  description,
  subtext,
  buttonText
}) => {
  const images = Array.isArray(imageList) ? imageList : imageList ? [imageList] : [];

  return (
    <section className={`portraits-section  ${class_Name} ${reverseOnDesktop ? 'reverse-on-desktop' : ''}`}>
      
      <div className="images-container">
        {videoSrc ? (
          <div className={`image-wrapper ${mediaOrientation === 'vertical' ? 'vertical-media' : ''}`}>
            <video
              src={videoSrc}
              className="portrait-img portrait-video"
              autoPlay
              loop
              muted
              playsInline
            />
          </div>
        ) : (
          images.map((image, index) => (
            <div
              className={`image-wrapper ${image.orientation === 'vertical' ? 'vertical-media' : ''}`}
              key={image.src || index}
            >
              <img
                src={image.src}
                alt={image.alt}
                className="portrait-img"
              />
            </div>
          ))
        )}
      </div>

      <div className="content-container">
        {title && (
          <div className="clr-dark-red margin-bottom-4 local-title">{title}</div>
        )}

        {description && (
          <p className="clr-dark-blue font-size-3 margin-bottom-4 description">
            {description}
          </p>
        )}

        {subtext && (
          <p className="clr-dark-red margin-bottom-5 subtext">
            {subtext}
          </p>
        )}

        {buttonText && (
          <button type="button" className="cta-button bg-dark-blue">
            {buttonText}
          </button>
        )}
      </div>
    </section>
  );
};

export default PortraitsSection;
